import { ChangeDetectionStrategy, Component, Input, Output, ViewEncapsulation, EventEmitter } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { ILightWeightUser } from '@fi-shared/models';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';

@Component({
    selector: 'fi-chat-conversation-manage-users-remove-container',
    template: `
        <fi-chat-conversation-users-list
            class="default-scroll-bar"
            [selectedUsers]="selectedUsers"
            [users]="users"
            [disabledUserIds]="disabledForRemovingUserIds"
            [isRippleEffect]="true"
            [isTooltipAvailable]="true"
            [tooltipText]="getDisabledUserTooltipFn.bind(this)"
            (onUserCardClick)="userCardClick($event)"
        />
        <div class="conversation-manage-users-footer" [ngClass]="{ disabled: isRemoveButtonDisabled() }">
            <button
                mat-button
                class="conversation-manage-users-footer-button"
                [disabled]="isRemoveButtonDisabled()"
                (click)="remove()"
            >
                {{ getRemoveButtonText() }}
            </button>
        </div>
    `,
    styleUrls: ['./fi-chat-conversation-manage-users-remove-container.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-chat-conversation-manage-users-remove-container' },
    standalone: false,
})
export class FiChatConversationManageUsersRemoveContainerComponent {
    @Input() users: ILightWeightUser[];
    @Input() disabledForRemovingUserIds: number[];
    @Output() removeUsers = new EventEmitter<ILightWeightUser[]>();
    selectedUsers: ILightWeightUser[] = [];

    constructor(
        private appTextService: AppTextService,
        private fiUserDataService: FiUserDataService,
    ) {}

    getDisabledUserTooltipFn = (userId: number) => {
        return this.appTextService.get(
            userId === this.fiUserDataService.getUserId()
                ? 'conversation.user_cant_self_remove'
                : 'conversation.user_select_disabled_tooltip',
        );
    };

    userCardClick(user: ILightWeightUser) {
        const userIdx = this.getUserIdIdx(user);
        if (userIdx === -1) {
            this.selectedUsers.push(user);
        } else {
            this.selectedUsers.splice(userIdx, 1);
        }
    }

    getRemoveButtonText() {
        return this.isRemoveButtonDisabled()
            ? this.appTextService.get('chat.select_members_to_remove')
            : this.appTextService.get('chat.remove_selected_members');
    }

    remove() {
        this.removeUsers.emit(this.selectedUsers);
    }

    isRemoveButtonDisabled() {
        return !this.selectedUsers.length;
    }

    private getUserIdIdx(user: ILightWeightUser): number {
        return this.selectedUsers.findIndex((selectedUser) => user.Id === selectedUser.Id);
    }
}
